import { createFileRoute } from '@tanstack/react-router';

import { IntegrationsSettingsLayout } from '~/features/integrations/components/integrations-settings-layout';

/**
 * Integrations layout route. Renders the settings-style shell (page header +
 * card nav + `<Outlet/>`) so nested integrations pages (Overview, Connections,
 * …) share one chrome. No guard here — the overview is open to any
 * authenticated tenant user; child routes add their own guards (e.g.
 * Connections is super-admin only).
 */
export const Route = createFileRoute('/_authenticated/_tenant/integrations')({
  component: IntegrationsSettingsLayout,
});
